var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGsLabsWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 246.7 51.7",
    style: {
      enableBackground: "new 0 0 246.7 51.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E2521;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#2DA736;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,19.3L37.3,37.4h22.9V13.2C54.8,13.2,52.3,15.6,49.7,19.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.3,37.6c4.4,0,7.9-2.1,10.4-5.7l12.8-18.6H25.3c-6.7,0-12.2,5.4-12.2,12.2S18.6,37.6,25.3,37.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.8,24.2v7.7c-0.9,0.2-1.8,0.2-2.6,0.2c-4.2,0-7.5-2-7.5-6.7c0-2.7,1-4.5,2.5-5.5c1.6-1.1,3.9-1.5,6.3-1.5 h7.7v-5.2h-8.9c-3,0-6.2,0.2-8.9,1.6c-3.6,1.8-5.9,5.2-5.9,10.6c0,8.2,5.9,12.3,13.6,12.2c2.8,0,7.3-0.5,10.2-1.4v-12H90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.4,24.7c-1.1-0.7-2.7-1.4-4.6-2.3c-1.1-0.5-1.8-0.9-2.2-1.2c-0.6-0.5-0.8-1.3-0.4-2 c0.3-0.6,1.1-0.9,1.9-0.9h8.8v-4.8h-9.3c-4.3,0-8.7,1.6-8.7,6.7c0,2.3,1.2,3.9,2.8,5.1c2.6,1.9,4.8,2.2,7.1,3.8 c0.9,0.6,1.1,1.3,0.8,2.2c-0.4,1-1.8,1.1-2.7,1.1h-7.8v5h9.7c4.4,0,8.5-2,8.5-7.1C120,27.6,118.6,26,116.4,24.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.4,24.5c-1.1-0.7-2.7-1.4-4.6-2.3c-1.1-0.5-1.8-0.9-2.2-1.2c-0.6-0.5-0.8-1.3-0.5-2 c0.3-0.6,1.1-0.9,1.9-0.9h8.8v-4.9h-9.4c-4.4,0-8.8,1.6-8.8,6.8c0,2.3,1.2,3.9,2.8,5.1c2.6,1.9,4.8,2.3,7.1,3.8 c0.9,0.6,1.1,1.3,0.8,2.2c-0.4,1-1.8,1.1-2.7,1.1h-7.8v5h9.7c4.4,0,8.5-2,8.5-7.1C233.1,27.4,231.7,25.8,229.4,24.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "151.8,37.4 133,37.4 133,13.4 140,13.4 140,31.7 151.8,31.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.5,25.3v-0.1c3.2-0.7,4.7-3,4.7-5.6c0-3.6-3.2-6.2-8.9-6.2h-14v24h14.5c5.9,0,9.2-2,9.2-7.3 C209.9,28,208.4,25.7,204.5,25.3 M193.4,18.2h5.6c2.1,0,3.3,0.9,3.3,2.5c0,1.7-1.5,2.6-3.4,2.6h-5.6L193.4,18.2L193.4,18.2z  M199.4,32.7h-6v-5.1h6.4c1.7,0,3.3,0.9,3.3,2.5C203,31.6,201.7,32.7,199.4,32.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.8,37.4h-7.2l-1.9-4.9h-10.2l-1.9,4.9h-7.2l10.4-24h7.8L182.8,37.4z M172,28.4l-3.4-8.8l-3.5,8.8 C165.1,28.4,172,28.4,172,28.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsLabsWhitecolor);
export default __webpack_public_path__ + "static/media/gs_labs_white+color.b7e35aeed9c686c187b6e2cb8bd6e00e.svg";
export { ForwardRef as ReactComponent };